// extracted by mini-css-extract-plugin
export default {"Notify":"Notify_Notify__fYvk-","Notify__heading":"Notify_Notify__heading__p5cag","Notify__content":"Notify_Notify__content__sqAvB","Notify__radios":"Notify_Notify__radios__at-DK"};